import { cn } from '@/lib/utils'

import { CaseUpdateHistoryFilters } from './ui/case-update-history-filters/case-update-history-filters'
import { CaseUpdateHistory } from './ui/case-update-history/case-update-history'

export const DashboardCaseUpdateHistoryPage = () => {
  return (
    <div className={cn('mt-6')}>
      <CaseUpdateHistoryFilters />

      <CaseUpdateHistory />
    </div>
  )
}
